var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-3 px-0"},[_c('h2',[_vm._v(_vm._s(_vm.$t('messages.heading')))]),_c('PolygonChat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }